<template>
  <component v-if="component"
    :is="component"
    :toolbarOption="toolbarOption"
    :tool="tool.name"
    :active="tool.active"
    :tag="tool.tag"
    :value="tool.value"
    :option="tool.option"
    @setValue="setToolValue"
    @setOption="setToolOption"
    @setActive="setToolActive" />
</template>

<script>
export default {
  name: 'Tool',
  props: [
    'toolbarOption',
    'tool',
    'toolbarState'
  ],
  computed: {
    loader () {
      if (!this.tool) {
        return null
      }
      return () => import(`./${this.tool.name}.vue`)
    }
  },
  data () {
    return {
      component: null
    }
  },
  mounted () {
    this.loader()
      .then(() => {
        this.component = () => this.loader()
      })
      .catch(() => {
        this.component = null
      })
  },
  methods: {
    setToolValue (data) {
      this.$emit('setValue', data)
    },
    setToolOption (data) {
      this.$emit('setOption', data)
    },
    setToolActive (data) {
      this.$emit('setActive', data)
    }
  }
}
</script>
